<h1 mat-dialog-title>Warning</h1>
<div mat-dialog-content style="margin-bottom: 10px;">
  {{data.message}}
</div>
<span style="margin-top:10px;">
<button *ngIf="data.lessThan" style="background-color: #bc5050;
border: #424242;
border-radius: 3px;
width: 100px;
height: 40px;
margin-top: 40px;
margin-right: 10px;" [mat-dialog-close]="" (click)="navigateAnyway()">Finish</button> <button *ngIf="data.lessThan" [mat-dialog-close]="" style="background-color: #ffffff;
    border: #424242;
    border-radius: 3px;
    width: 100px;
    height: 40px;
    margin-top: 40px;
    margin-right: 10px;"> Go Back</button>
<button *ngIf="!data.lessThan" style="background-color: #bc5050;
border: #424242;
border-radius: 3px;
width: 100px;
height: 40px;
margin-top: 40px;
margin-right: 10px;" [mat-dialog-close]="" (click)="navigateAnyway()">Finish</button> <button *ngIf="!data.lessThan" [mat-dialog-close]="" style="background-color: #ffffff;
    border: #424242;
    border-radius: 3px;
    width: 100px;
    height: 40px;
    margin-top: 40px;
    margin-right: 10px;"> Go Back</button>

</span>
